import { Context, useContext } from "react";

import IntegrationSetupContext, {
  IntegrationSetupContextState,
} from "./IntegrationSetupContext";

const useIntegrationSetupContext = (): IntegrationSetupContextState =>
  useContext(IntegrationSetupContext as Context<IntegrationSetupContextState>);

export default useIntegrationSetupContext;
